import type { SituacaoUsuario } from '@/types/domain'

export interface AdministradorResumo {
  id: string | null
  usuarioId: string
  nome: string | null
  email: string | null
  telefone1: string | null
  telefone1DDI: string | null
  idAnyDesk: string | null
  situacao: SituacaoUsuario
}

export const STATUS_ADMINISTRADOR = {
  Todas: 'Todas',
  Ativas: 'Ativas',
  Inativas: 'Inativas',
} as const

export type StatusAdministrador = (typeof STATUS_ADMINISTRADOR)[keyof typeof STATUS_ADMINISTRADOR]

export const situacaoAdministradorBadges = [
  { value: STATUS_ADMINISTRADOR.Ativas, label: 'Ativos', tone: 'success' as const },
  { value: STATUS_ADMINISTRADOR.Inativas, label: 'Inativos', tone: 'neutral' as const },
]

export interface ListarAdministradoresQuery {
  busca?: string | null
  situacao: StatusAdministrador
  pageNumber: number
  pageSize: number
}

export interface CriarAdministradorPayload {
  nome: string
  email: string
  telefone: string
  telefoneDDI: string
}

export interface AtualizarAdministradorPayload {
  id: string
  nome: string
  email: string
  telefone: string
  telefoneDDI: string
}
